export default {
  availableSeatCount: 'availableSeatCount',
  totalSeatCount: 'totalSeatCount',
  travelClass: 'travelClass',
}
